import { render, staticRenderFns } from "./head2.vue?vue&type=template&id=67fb5861&scoped=true&"
import script from "./head2.vue?vue&type=script&lang=js&"
export * from "./head2.vue?vue&type=script&lang=js&"
import style0 from "./head2.vue?vue&type=style&index=0&id=67fb5861&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.10.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67fb5861",
  null
  
)

export default component.exports